import { MdOutlineVpnKey } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import Chat from "../../../../assets/settings/Chat.svg";
import EarthIcon from "../../../../assets/settings/EarthIcon.svg";
import Home from "../../../../assets/settings/Home.svg";
import Info from "../../../../assets/settings/Info.svg";
import Message from "../../../../assets/settings/Message.svg";
import Phone from "../../../../assets/settings/Phone.svg";

const ShowSalonData = ({ email, name, phone, site }: any) => {
  // const user = useSelector((state: any) => state?.user);
  // console.log(user, "user");
  return (
    <div className="flex flex-col items-center w-full gap-4 md:pl-12">
      <h5 className="w-full mb-6 text-lg font-semibold">
        <FormattedMessage id="salonInfo" />
      </h5>
      <div className="flex items-center w-full px-6 py-4 bg-white rounded-lg max-lg:flex-col justify-evenly max-md:px-3">
        <div className="flex items-center gap-1 md:min-w-[25rem] w-full max-lg:mb-4">
          <img src={Home} alt="salon name" />
          <span className="text-[#75757E]">
            <FormattedMessage id="salonName" />
          </span>
          <span className="text-[#020418]">{name}</span>
        </div>
        <div className="flex justify-end gap-4 max-md:flex-col lg:items-center w-fit max-lg:w-full">
          {phone && (
            <div className="flex justify-end w-full gap-2 lg:items-center max-lg:w-fit">
              <img src={Phone} alt="salon phone" />
              <span className="text-[#020418] text-sm" dir="ltr">
                {phone}
              </span>
            </div>
          )}
          {email && (
            <div className="flex justify-end w-full gap-2 lg:items-center max-lg:w-fit">
              <img src={Message} alt="salon email" />
              <span className="text-[#020418] text-sm">{email}</span>
            </div>
          )}
          {site && (
            <div className="flex justify-end w-full gap-2 lg:items-center max-lg:w-fit">
              <img src={EarthIcon} alt="salon site" />
              <span className="text-[#020418] text-sm">{site}</span>
            </div>
          )}
        </div>
      </div>
      <div className="flex items-center justify-between w-full px-6 py-4 bg-white rounded-lg max-md:flex-col max-md:gap-2">
        <div className="flex items-center w-1/2 gap-1">
          <MdOutlineVpnKey className="w-5 h-5 text-color-primary" />
          <span className="text-[#75757E]">
            <FormattedMessage id="Password1" />{" "}
          </span>
          <span className="w-2 h-2 bg-black rounded-full" />
          <span className="w-2 h-2 bg-black rounded-full" />
          <span className="w-2 h-2 bg-black rounded-full" />
          <span className="w-2 h-2 bg-black rounded-full" />
          <span className="w-2 h-2 bg-black rounded-full" />
          <span className="w-2 h-2 bg-black rounded-full" />
          <span className="w-2 h-2 bg-black rounded-full" />
          <span className="w-2 h-2 bg-black rounded-full" />
        </div>
      </div>
      <div className="flex items-center justify-between w-full px-6 py-4 bg-white rounded-lg max-md:flex-col max-md:gap-2">
        <div className="flex items-center w-1/2 gap-1">
          <img src={Chat} alt="salon lang" />
          <span className="text-[#75757E]">
            <FormattedMessage id="salonLanguage" />
          </span>
          <span className="text-[#020418]">
            <FormattedMessage id="arabic" />
          </span>
        </div>
        <div className="flex items-center justify-end w-full gap-2">
          <img src={Info} alt="salon info" />
          <span className="text-[#75757E] text-sm">
            <FormattedMessage id="teamMembersNotice" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default ShowSalonData;
